module.exports = __webpack_public_path__ + "8cd283b11fe41ad51c45d7e99d66722d.pdf";